<template>
    <!-- <div class="app-card-title"> -->
        <div class="app-contextual-link buttom-menu" v-if="fullScreen || reloadable || closeable">
            <v-menu transition="scale-transition" origin="right top" bottom left>
                <!-- <v-btn class="ma-0" icon slot="activator">Download
                    <v-icon>more_vert</v-icon>
                </v-btn> -->
                <v-btn class="ma-0" flat  color="grey" slot="activator">Download</v-btn>
                <v-list class="app-card-action">
                    <v-list-tile @click="$emit('onCollapse')" v-if="fullScreen">
                        <i class="zmdi zmdi-fullscreen primary--text mr-2 fs-14"></i>
                        <span>{{$t("message.fullScreen")}}</span>
                    </v-list-tile>
                    <v-list-tile @click="$emit('onExportPdf')">
                        <i class="zmdi zmdi-download --text mr-2 fs-14"></i>
                        <span>{{$t("Download PDF")}}</span>
                    </v-list-tile>
                    <v-list-tile @click="$emit('onExportPpt')">
                        <i class="zmdi zmdi-download --text mr-2 fs-14"></i>
                        <span>{{$t("Download PPT")}}</span>
                    </v-list-tile>
                    <v-list-tile @click="$emit('onExportExcel')" v-if="onExportExcel">
                        <i class="zmdi zmdi-download --text mr-2 fs-14"></i>
                        <span>{{$t("Download Excel")}}</span>
                    </v-list-tile>
                    <v-list-tile @click="$emit('onReload')" v-if="reloadable">
                        <i class="zmdi zmdi-refresh success--text mr-2 fs-14"></i>
                        <span>{{$t("message.reload")}}</span>
                    </v-list-tile>
                    <!-- <v-list-tile @click="$emit('onClose')" v-if="closeable">
                        <i class="zmdi zmdi-close mr-2 error--text fs-14"></i>
                        <span>{{$t("message.close")}}</span>
                    </v-list-tile> -->
                </v-list>
            </v-menu>
        </div>
    <!-- </div> -->
</template>
<style scoped>
.buttom-menu{
    padding: 1rem 1.25rem;
    right: 0;
    text-align: end;
    margin-top: -68px;
}
</style>

<script>
export default {
    props: [
        "heading",
        "closeable",
        "reloadable",
        "fullScreen",
        "withTabs",
        "tabs",
        "onCollapse",
        "onReload",
        "onClose",
        "onChangeTabCallback",
        "exportexcel",
    ],
    data() {
        return {
            activeTab: 0
        };
    },
    computed: {
        onExportExcel() {
            if (this.exportexcel === undefined) {
                return true
            } else {
                return this.exportexcel;
            }
        }
    },
    methods: {
        onChangeTab(value) {
            this.activeTab = value;
            this.$emit("onChangeTabCallback", value);
        }
    }
};
</script>